<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { getIndex, setLocation, generateUUID } from "@/utils";
import moment from "moment";
import swal from "sweetalert";

import { getLocations, getLocationGroup } from "@/api/locations";
import {getBasketRetention ,getMenuItemCategory, getBasketQuadrant} from "@/api/analytics";
import {getRevenueCenters} from "@/api/campaigns";

import DataTableSection from "@/view/components/helper/datatable/datatableWithDataPass.vue";
import QuadrantChart from "@/view/components/basket_analytics/quadrantChart.vue";

const startOfMonth = moment()
  .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");

const endOfMonth = moment()
  .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "basket-analytics",
  components: {
    VueCtkDateTimePicker,
    DataTableSection,
    QuadrantChart
  },
  data() {
    return {
      form: {
        selectedItems: [],
        selectedLocationOrGroup: "locations",
        dtpicker: { start: startOfMonth, end: endOfMonth },
        selectedCustomerType: ["all"],
        // selectedRevenueList: ['in-store',"online","delivery"],
        selectedRevenueList: [],
        selectedBasketType: ["all"],
        selectedBasketTable: []
      },
      maxDate: moment().format("YYYY-MM-DD"),
      basketType: [
        { text: "All", value: "all"},
        { text: "Appetizer", value: "appetizer"},
        { text: "Entrees", value: "entrees"},
        { text: "Desserts", value: "desserts"}
      ],
      customerType: [
        { text: "All", value: "all"},
        { text: "Trackable", value: "trackable"},
        { text: "Marketable", value: "marketable"}
      ],
      locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      categoryOptions: [
        { text: "Sales", value: "sales" },
        { text: "Average Check", value: "average_check" },
        { text: "Traffic", value: "traffic" },
        { text: "Recency", value: "recency" },
        { text: "Frequency", value: "frequency" }
      ],
      selectedLocationGroups: [],
      grouplocationsOptionsv2:[],
      grouplocationsOptionsv2Copy:[],
      groups:[],
      locations: [],
      searchTerm: null,
      searchLocationGroupTerm: null,
      locationsCopy: [],
      locationsOptions: [],
      maxDisplay: 1,
      snackbar: false,
      text: "",
      vertical: true,
      firstLoadDone: false,
      loading: false,
      loadingCircle: false,
      overlayText: "Please select filters",
      stickyNav: '',
      // revenueCenterList:[
      //   { text: "In-Store", value: "in-store" },
      //   { text: "Online", value: "online" },
      //   { text: "Delivery", value: "delivery" }
      // ],    
      revenueCenterList:[],    
      searchTextTable: '',
      openPanel: [0,1],
      basketRetentionTableContent: [],
      tableDataParam: {
        headers: [
          {
            text: "Menu Category",
            align: "center",
            sortable: true,
            value: "basketType",
            width: '120px' 
          },
          { text: "Basket Item", value: "description", align: "center", width: '100px' },
          { text: "Orders", value: "total_orders", align: "center", width: '100px' },
          { text: "Sales", value: "total_price", align: "center", width: '100px' },
          { text: "Retention", value: "reorder_rate", align: "center", width: '100px' },
          { text: "Rank", value: "rank", align: "center", width: '100px' },
        ]
      },
      customRenderers: [
        {field: "total_orders"},
        {field: "reorder_rate"},
        {field: "total_price"},
        {field: "rank"},
      ],
      totalRank: 0
    };
  },
  async beforeMount() {
    var accountSetting = await this.$store.getters["getAccountSettings"];
    if (!accountSetting.length){
      await this.$store.dispatch("getAccountSettings");
    }
    try {
      let menuDataBasket = await getMenuItemCategory()
      this.basketType = [
        ...menuDataBasket.data.map(list => {
          return {
            value: list.category,
            text: list.category
          };
        })
      ];
      this.basketType.unshift({ text: "All", value: "all"}) // manual add this, 
    } catch (error) {
      console.log('-- Error: ',error)
    }
    
  },
  async mounted() {
    await this.firstLoadDatePick();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Basket Analytics" }]);
    this.overlayText = "Populating filters option ..."
    this.goLoad()
    try {
      let location = await getLocations();
      // let locationGroup = await getLocationGroup();
      
      this.locations = location
      // let index = this.getIndex(this.locations);
      // let selected = this.locations[index];
      // this.form.selectedItems.push(selected.id);
      // this.form.selectedItems = this.form.selectedItems.flat()

      // this.groups = locationGroup
      this.$nextTick(() => {
        this.setLocationGroups()
        this.setLocations()
      })

      let revenueCenterList = await getRevenueCenters()
      this.revenueCenterList = [
        ...revenueCenterList.map(list => {
          return {
            value: list.name.toLowerCase(),
            text: list.name
          };
        })
      ];
      this.form.selectedRevenueList= [this.revenueCenterList[0]['value']],
      
      this.doneLoad()
      setTimeout(() => {
        this.onSearch()
        this.openPanel = [0]
      }, 100);

    } catch (error) {
      console.log('- Error: ', error)
      this.loading = true
      this.loadingCircle = false
      this.overlayText = "Something went wrong. Please try again later"
    }
  },
  computed: {
    likesAllItemsRevenue() {
      return this.form.selectedRevenueList.length === this.revenueCenterList.length;
    },
    likesSomeItemRevenue() {
      return this.form.selectedRevenueList.length > 0 && !this.likesAllItemsRevenue;
    },
    likesAllItemsBasket() {
      return this.form.selectedBasketType.length === this.basketType.length;
    },
    likesSomeItemBasket() {
      return this.form.selectedBasketType.length > 0 && !this.likesAllItemsBasket;
    },
    likesAllCustomerType() {
      return this.form.selectedCustomerType.length === this.customerType.length;
    },
    likesSomeCustomerType() {
      return this.form.selectedCustomerType.length > 0 && !this.likesAllCustomerType;
    },
    likesAllItems() {
      return this.form.selectedItems.length === this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.form.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconRevenue() {
      if (this.likesAllItemsRevenue) return "mdi-close-box";    
      if (this.likesSomeItemRevenue) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconCustomer() {     
      if (this.likesAllCustomerType) return "mdi-close-box";
      if (this.likesSomeCustomerType) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconBasket() {
      if (this.likesAllItemsBasket) return "mdi-close-box";
      if (this.likesSomeItemBasket) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() {
      return this.selectedLocationGroups.length === 30  || this.selectedLocationGroups.length === this.grouplocationsOptionsv2.length;
    },
    likesSomeGroupItem() {
      return this.selectedLocationGroups.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    getContentBasket(){
      return this.basketRetentionTableContent
    },
    searchTrigger() {
      return this.searchTextTable;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    "form.selectedItems"() {
      this.form.location_ids = this.form.selectedItems
    },
    "form.dtpicker"(newVal) {
      if (newVal == undefined) {
        let last365 = moment(this.maxDate).subtract(1, 'years')
        last365 = last365.format("YYYY-MM-DD");
        let today = moment(this.maxDate)
        today = today.format("YYYY-MM-DD");

        this.form.dtpicker  = { start: last365, end: this.maxDate };
      }
    },
    searchTrigger(q) {
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.updateSearchField(q)
    },
  },
  methods: {
    triggerRefreshQuadrant(){
      let componentEvent = this.$refs.quadrantComponent
      componentEvent.refretshQuadrant()
    },
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    displayFloat(value){
      return parseFloat(value)
    },
    displayMoneyFormatAmount(value) {
      let options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
      };
      let newVal = 0

      if (value < 0) {
        newVal = Number(value).toLocaleString('en', options);
        newVal = newVal.replaceAll('-', '-$')
        return newVal;
      }
      return "$" + Number(value).toLocaleString('en', options);
    },
    
    displayCommaSeparatedNumber(value){
      return  Number(value.toFixed(0)).toLocaleString()
    },
    displayCommaSeparatedNumberTwoDec(value){
      let options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
      };
      return  Number(value).toLocaleString('en', options);
    },
    displayPercentageFormatValue(value) {
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));      
      return total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")+"%";
    },
    toggleRevenue() {
      this.$nextTick(() => {
        if (this.likesAllItemsRevenue) {
          this.form.selectedRevenueList = [];
        } else {
          let data = [];
          for (let i = 0; i < this.revenueCenterList.length; i++) {
            let item = this.revenueCenterList[i];
            data.push(item.value);
          }
          this.form.selectedRevenueList = data;
        }
      });
    },
    toggleBasket() {
      this.$nextTick(() => {
        if (this.likesAllItemsBasket) {
          this.form.selectedBasketType = [];
        } else {
          let data = [];
          for (let i = 0; i < this.basketType.length; i++) {
            let item = this.basketType[i];
            data.push(item.value);
          }
          this.form.selectedBasketType = data;
        }
      });
    },
    toggleCustomerType() {
      this.$nextTick(() => {
        if (this.likesAllCustomerType) {
          this.form.selectedCustomerType = [];
        } else {
          let data = [];
          for (let i = 0; i < this.customerType.length; i++) {
            let item = this.customerType[i];
            data.push(item.value);
          }
          this.form.selectedCustomerType = data;
        }
      });
    },
    async exportItems(){
      if (this.form.selectedBasketTable.length <= 0) {
        swal("Notice", "No selected item to Export");
      }else{
        let items = [];
          for (let i = 0; i < this.form.selectedBasketTable.length; i++) {
            let item = this.form.selectedBasketTable[i];
            let newCol = {}
            this.tableDataParam.headers.forEach((headerItem) => {
              newCol[headerItem.text] = item[headerItem.value]
            });
            items.push(newCol)
          }
          let csv = this.$papa.unparse(items);
          await this.$papa.download(
              csv,
              `Basket Retention Table-${moment().format("YYYY-MM-DD-HH-mm")}`
          );
      }

    },
    goLoad(){
      this.loading = true
      this.loadingCircle = true
    },
    doneLoad(){
      this.loading = false
    },
    handleScroll (event) {
      this.stickyNav = ''
      if(window.top.scrollY >= 80){
        this.stickyNav = 'stick-nav'
      }
    },
    setLocations() {
      this.snackbar = true;
      this.text = "Loading locations...";
      this.locationsOptions = [
        ...this.locations.map((list) => {
          return {
            value: list.id,
            text: `${list.name} ${list.full_address}`,
            name: list.name,
            full_address: list.full_address,
          };
        }),
      ];
      this.locationsCopy = [...this.locationsOptions];
      this.form.selectedItems.push(this.locationsOptions.map(list => list.value))
      this.form.selectedItems = this.form.selectedItems.flat()

      // this.onSearch();
      this.snackbar = false;
    },
    setLocationGroups() {
      this.grouplocationsOptionsv2 = [
        ...this.groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.grouplocationsOptionsv2Copy = [...this.grouplocationsOptionsv2];
      this.selectedLocationGroups = [...this.grouplocationsOptionsv2];
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          this.selectedLocationGroups = [];
        } else {
          let data = [];
          for (let i = 0; i < this.grouplocationsOptionsv2.length; i++) {
            let item = this.grouplocationsOptionsv2[i];
            data.push(item);
          }
          this.selectedLocationGroups = data;
        }
      });
    },
    capitalize(str) {
      if(!str){
        return ''
      }
      return (str = str
      .split(" ")
      .map(
        ([firstChar, ...rest]) =>
          firstChar.toUpperCase() + rest.join("").toLowerCase()
      )
      .join(" "));
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.form.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item.value);
          }
          this.form.selectedItems = data;
          this.form.selectedItems = this.form.selectedItems.flat()
          console.log('-=-=- ALL: ',this.form.selectedItems)
        }
      });
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
     
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.grouplocationsOptionsv2.length == 0) {
        this.grouplocationsOptionsv2 = this.grouplocationsOptionsv2Copy;
      }
      this.grouplocationsOptionsv2 = this.grouplocationsOptionsv2.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    async onSearch() {
      this.goLoad()
      this.overlayText = "Fetching result(s) ..."

      if (this.form.selectedItems.length <= 0 || 
          this.form.selectedCustomerType <= 0 ||
          this.form.selectedBasketType <= 0 ||
          this.form.revevenueSelect <= 0 ||
          this.form.selectedRevenueList <= 0 ){
        swal("Notice", "Please fill up the filter before Search.");
        this.$nextTick(() => {
          this.doneLoad()
        })
        return false
      }
      let revevenueSelect = this.form.selectedRevenueList

      if(revevenueSelect.length == this.revenueCenterList.length){
        revevenueSelect = ['all']
      }
      let payload = {
        location_ids: this.form.selectedItems,
        start_date: this.form.dtpicker.start,
        end_date: this.form.dtpicker.end,
        customer_types: this.form.selectedCustomerType,
        channel_types: revevenueSelect,
        menu_items_col: this.form.selectedBasketType,
      }
      console.log(payload)

      let bastetRetentionTableData = await getBasketRetention(payload)
      if(bastetRetentionTableData){
        this.basketRetentionTableContent = bastetRetentionTableData
        this.totalRank = Math.max(...this.basketRetentionTableContent.map(item => item.rank))
        console.log('--- TOTAL: ', this.totalRank)
      }

      this.$nextTick(() => {
        this.doneLoad()
      })
    },
    async firstLoadDatePick() {
      var accountSetting = await this.$store.getters["getAccountSettings"];
      if (!accountSetting.length){
        await this.$store.dispatch("getAccountSettings");
        accountSetting = await this.$store.getters["getAccountSettings"];
      }
      let aggregatedDate = accountSetting.company_details.company['aggregated_date']
      this.maxDate = moment(aggregatedDate).format("YYYY-MM-DD")

      if (!this.firstLoadDone) {
        this.firstLoadDone = true;

        let current = new Date();

        let enddate = `${current.getFullYear()}-${current.getMonth() +
          1}-${current.getDate()}`;
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() +
          1}-${current.getDate()}`;

        this.form.dtpicker.start = startdate; // this set the value of date picker //initial first load set date range
        this.form.dtpicker.end = enddate;
        if ( moment(this.maxDate).format("YYYY-MM-DD") < moment(enddate).format("YYYY-MM-DD") ){
          let last365 = moment(this.maxDate).subtract(1, 'years')
          last365 = last365.format("YYYY-MM-DD");

          this.form.dtpicker.start = last365;
          this.form.dtpicker.end = moment(this.maxDate).format("YYYY-MM-DD");
        }
      }
    },
    whenDtClosed() {
      if (this.form.dtpicker.end == null && this.form.dtpicker.start != null) {
        this.form.dtpicker.end = this.form.dtpicker.start;
      }
    },
    syncSelectedItem(selectedCollection) {
      this.form.selectedBasketTable = selectedCollection
    },
    tableClass(data){
      return ''
    },
    displayTotalOf(value){
      return value + ' of ' + this.totalRank.toString()
      // return value
    }
  },
  
};
</script>

<template>
  <v-app class="bg-transparent ca-page">
    <v-main>
      <!-- Subheader -->
      <div class="pl-3 pr-3 pt-4 pb-4 d-flex align-items-center justify-content-center zindex-99 filter-container" :class="stickyNav">
        
        <div class="mr-2" style="width: 200px;">
          <VueCtkDateTimePicker
            @is-hidden="whenDtClosed()"
            :max-date="maxDate"
            v-model="form.dtpicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
          />
        </div>

        <!-- <div class="mr-2" style="width: 200px;height: 42px;">
          <v-select
            v-model="form.selectedLocationOrGroup"
            :items="locationOrGroupOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          ></v-select>
        </div> -->

        <div class="mr-2" style="width: 250px;height: 42px;" v-if="form.selectedLocationOrGroup == 'locations'">
          <v-select
            v-if="form.selectedLocationOrGroup == 'locations'"
            v-model="form.selectedItems"
            :items="locationsOptions"
            label="Location"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchTerm"
                    placeholder="Search"
                    @input="filterLocations"
                    @blur="filterLocationsBlur"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedItems.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedItems.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedItems.length }} selected
              </span>
            </template>
            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.full_address }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>


        <div class="mr-2" style="width: 250px;height: 42px;" v-if="form.selectedLocationOrGroup == 'location_groups'">
          <v-select
            v-if="form.selectedLocationOrGroup == 'location_groups'"
            v-model="selectedLocationGroups"
            :items="grouplocationsOptionsv2"
            label="Group Location"
            required
            dense
            outlined
            return-object
            multiple
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchLocationGroupTerm"
                    placeholder="Search"
                    @input="filterLocationGroups"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleLocationGroup">
                <v-list-item-action>
                  <v-icon
                    :color="selectedLocationGroups.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ groupicon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="selectedLocationGroups.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ selectedLocationGroups.length }} selected
              </span>
            </template>
            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>
        
        <div class="mr-2" style="width: 150px;height: 42px;">
          <v-select
            v-model="form.selectedCustomerType"
            :items="customerType"
            label="Customer Type"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
          <template v-slot:prepend-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleCustomerType">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedCustomerType.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconCustomer }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedCustomerType.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedCustomerType.length }} selected
              </span>
            </template>
          </v-select>
        </div>
        <div class="mr-2" style="width: 150px;height: 42px;">
          <v-select
            label="Revenue Centers"
              v-model="form.selectedRevenueList"
              :items="revenueCenterList"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              :menu-props="{ top: false, offsetY: true }"
            >
            <template v-slot:prepend-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleRevenue">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedRevenueList.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconRevenue }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedRevenueList.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedRevenueList.length }} selected
              </span>
            </template>
          </v-select>
        </div>


        <div class="mr-2" style="width: 150px;height: 42px;">
          <v-select
            label="Basket"
              v-model="form.selectedBasketType"
              :items="basketType"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              :menu-props="{ top: false, offsetY: true }"
            >
            <template v-slot:prepend-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleBasket">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedBasketType.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconBasket }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedBasketType.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedBasketType.length }} selected
              </span>
            </template>
          </v-select>
        </div>


        <div>
          <v-btn
            md
            depressed
            color="primary"
            style="height:40px;"
            @click="onSearch()"
            :disabled="loading"
          >
            <v-icon> mdi-magnify</v-icon>
          </v-btn>
        </div>
      </div>


      <v-expansion-panels
        v-model="openPanel"
        multiple
      >

        <!-- <v-expansion-panel>
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              Basket Retention Quandrant
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="local-market-accord">
            <div class="dd-div">
              Filter....
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel> -->
        <v-expansion-panel @click.native="triggerRefreshQuadrant">
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              Quadrant Chart
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="local-market-accord">
            <div>
              <quadrant-chart
                :quadrantData="basketRetentionTableContent"
                ref="quadrantComponent"
              >
              </quadrant-chart>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              Basket Retention Table
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="local-market-accord">
            <div class="dd-div">
              <!-- filter.... -->
            </div>
            <div class="d-flex">
              <div class="mr-2" style="width: 90px; display:inline-block;vertical-align: top;">
                <v-btn 
                    md
                    depressed
                    color="primary"
                    style="height:40px;"
                    @click="exportItems()"> 
                    <v-icon left> mdi-file-export</v-icon>
                  Export
                </v-btn>
              </div>
              <div class="ml-auto p-2">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <b-icon icon="search"></b-icon>
                    </div>
                  </div>
                  <b-form-input v-model="searchTextTable"></b-form-input>
                </div>
              </div>
            </div>
            <div>
              <data-table-section
                :tableParam="this.tableDataParam"
                :tableContent="getContentBasket"
                :customRenderers="this.customRenderers"
                :isSelectEnabled="true"
                :itemRowClasses="tableClass"
                :selectKey="'index'"
                @datatableSelectedItem="syncSelectedItem"
                ref="dataTableComponent"
              >
                <template v-slot:total_ordersparams="{ item }"> {{displayCommaSeparatedNumber(item.total_orders)}} </template>
                <template v-slot:total_priceparams="{ item }"> {{displayMoneyFormatAmount(item.total_price)}} </template>
                <template v-slot:rankparams="{ item }">{{displayTotalOf(item.rank)}} </template>
                <template v-slot:reorder_rateparams="{ item }">{{displayCommaSeparatedNumberTwoDec(item.reorder_rate*100)}}% reorders </template>
              </data-table-section>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        

      </v-expansion-panels>

  
      <div>
        <v-overlay :value="loading">
          <div class="text-center">
            <p>{{overlayText}}</p>
            <v-progress-circular v-if="loadingCircle" indeterminate size="30"></v-progress-circular>
          </div>
        </v-overlay>
        <v-snackbar
          v-model="snackbar"
          :vertical="vertical"
          content-class="background:red"
          color="danger"
          dark
        >
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>

      


      
    </v-main>
  </v-app>
</template>

<style scoped>
.per-section{
  padding-top: 20px;
  border: 1px solid #00000059;
  border-radius: 25px;
  margin-top: 30px;
}
.filter-container{
    background-color: white;
    margin-bottom: 16px;
    border-radius: 5px;
    /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); */
}
.v-tooltip__content {
    width: 50vw !important;
    left: auto !important;
    right: 30px !important;
}
.label-txt{
  color: rgba(0,0,0,.6);
  font-size: 16px;
  padding-bottom: 3px;
  right: 4px;
  bottom: 5px;
  position: relative;
}
.zindex-99{
  position: relative;
  z-index: 10;
}

.subheader {
  background: #e9eaf3 !important;
}

.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}

.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}

.content-box {
  margin-top: 40px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}
.v-tooltip--bottom {
  background: white;
  color: black;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.mid-spa{
  position: relative;
  bottom: 5px;
}

@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}
.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}


.ca-page .v-expansion-panel::before{
  box-shadow: none !important;
}

.ca-page .v-expansion-panel--active .accord-lbl span {
  border-bottom: 2px inset #a8aee857;
  width: auto !important;
  display: block;
  position: absolute;
  border-radius: 3px;
  padding-bottom: 3px;
}

.ca-page .v-expansion-panel-header.accord-lbl:hover {
  background-color: #e3e6ffe8 !important;
  border: 1px solid #5966db54;
}

.ca-page .v-expansion-panel-header.accord-lbl.v-expansion-panel-header--active{
  background-color: #ffffff !important;
  border: none
}

.ca-page .accord-lbl,
.ca-page .v-expansion-panel-header.accord-lbl.v-expansion-panel-header--active:hover {
  font-size: 15px;
}
.stick-nav{
  position: fixed;
  max-width: 84%;
  width: 100%;
  top: 65px;
  background-color: #dee0f4;
}
.stick-nav{
  position: fixed;
  max-width: 84%;
  width: 100%;
  top: 65px;
  background-color: #dee0f4;
}
.stick-nav div{
  float: left;
}
@media only screen and (max-width: 1200px) {
  .stick-nav{
    width: 80%;
  }
}
@media only screen and (max-width: 1050px) {
  .stick-nav{
    width: 76%;
  }
  .stick-nav .v-select {
    max-width: 93px;
  }
}
.dd-div{
  top: 10px;
  position: absolute;
  right: 70px;
}

</style>
